module.exports = __webpack_public_path__ + "static/media/caret-left.f07b36d9.svg";